import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import Layout from './hoc/Layout/Layout';
import BusRoutes from './screens/BusRoute/BusRoutes';
import LTrain from './screens/LTrain/LTrain';
import Favorites from './screens/Favorites/Favorites';
import Destinations from './screens/Destination/Destinations';
import BusStops from './screens/BusStop/BusStops';
import BusStopPredictions from './screens/Prediction/BusStopPredictions';
import TrainStations from './screens/TrainStation/TrainStations';
import TrainStationPredictions from './screens/Prediction/TrainStationPredictions';

const App = () => {

  const routes = (
    <Switch>
      <Route path="/favorites" component={Favorites} />
      <Route path="/train" component={LTrain} />
      <Route path="/destination" component={Destinations} />
      <Route path="/busStops" component={BusStops} />
      <Route path="/busStopPrediction" component={BusStopPredictions} />
      <Route path="/trainStations" component={TrainStations} />
      <Route path="/trainStationPredictions" component={TrainStationPredictions} />
      <Route path="/busRoutes" component={BusRoutes} />
      <Redirect to="/busRoutes" />
    </Switch>
  );

  return (
    <div>
      <Layout>
        {routes}
      </Layout>
    </div>
  );
}

export default App;
